import PropTypes from 'prop-types';
import * as S from './styled';

const getManagePanelStyle = (size) => {
  if (!size) {
    return null;
  }
  const [width, height] = size;
  return { width, height };
};

const Header = ({ collapsed, title, icons, isFixedHeight }) => {
  const leftIcons = icons.filter((icon) => icon.placement === 'left');
  const rightIcons = icons.filter((icon) => icon.placement === 'right');
  return (
    <S.Header
      collapsed={collapsed}
      isFixedHeight={isFixedHeight}
    >
      <S.ManagePanel iconsCount={leftIcons.length}>
        {leftIcons.map(({ name, callback, Icon, size }) => (
          <S.ManagePanelIcon
            onClick={callback}
            key={name}
            style={getManagePanelStyle(size)}
          >
            <Icon size={size} />
          </S.ManagePanelIcon>
        ))}
      </S.ManagePanel>
      <S.Title>{title}</S.Title>
      <S.ManagePanel iconsCount={rightIcons.length}>
        {rightIcons.length === 0 && <S.ManagePanelIconPlaceholder />}
        {rightIcons.map(({ name, callback, Icon, size, props = {} }) => (
          <S.ManagePanelIcon
            onClick={callback}
            key={name}
            style={getManagePanelStyle(size)}
          >
            <Icon
              size={size}
              {...props}
            />
          </S.ManagePanelIcon>
        ))}
      </S.ManagePanel>
    </S.Header>
  );
};

Header.defaultProps = {
  title: '',
  icons: [],
  collapsed: true,
  isFixedHeight: true,
};

Header.propTypes = {
  title: PropTypes.string,
  icons: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      Icon: PropTypes.elementType,
      size: PropTypes.array,
      callback: PropTypes.func,
      placement: PropTypes.oneOf(['left', 'right']),
    })
  ),
  collapsed: PropTypes.bool,
  isFixedHeight: PropTypes.bool,
};

export default Header;
